import getCertInfoFromServer from 'owa-smime-adapter/lib/services/getCertInfoFromServer';
import GetCertsInfoResponse from 'owa-service/lib/contract/GetCertsInfoResponse';
import SmimeCustomError from './SmimeCustomError';
import SmimeContext from '../store/schema/SmimeContext';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import ChainValidityStatus from '../store/schema/ChainValidityStatus';

export default async function validateSigningCertificate(certRawData: string): Promise<string> {
    const certValidationResponse: GetCertsInfoResponse = await getCertInfoFromServer(
        certRawData,
        true /* isSend */
    );
    if (certValidationResponse?.IsValid) {
        return certRawData;
    } else {
        let errorCode: SmimeErrorStateEnum = SmimeErrorStateEnum.UnknownError;
        switch (certValidationResponse?.ChainValidityStatus) {
            case ChainValidityStatus.UntrustedRoot:
            case ChainValidityStatus.UntrustedTestRoot:
            case ChainValidityStatus.InternalChainFailure:
            case ChainValidityStatus.ValidSelfSigned:
                errorCode = SmimeErrorStateEnum.WarningSmimeChosenCertificateIsUntrusted;
                break;

            // When the cert has been revoked
            case ChainValidityStatus.Revoked:
            case ChainValidityStatus.CertificateRevoked:
                errorCode = SmimeErrorStateEnum.WarningSmimeChosenCertificateIsRevoked;
                break;

            // When the cert cannot be verified due to some problems (e.g. the CA server is offline)
            case ChainValidityStatus.NoRevocationCheck:
            case ChainValidityStatus.RevocationFailure:
            case ChainValidityStatus.RevocationOffline:
            case ChainValidityStatus.SignatureFailure:
                errorCode = SmimeErrorStateEnum.WarningSmimeCannotVerifyChosenCertificate;
                break;

            // When the cert itself is not correct (e.g. the period of the cert is invalid), or any other cases
            default:
                errorCode = SmimeErrorStateEnum.WarningSmimeChosenCertificateIsInvalid;
                break;
        }

        throw new SmimeCustomError(
            'S/MIME: Unable to verify signing certificate',
            errorCode,
            SmimeContext.GenericSendingMessage
        );
    }
}
